<template>
	<div class="home">
		<img alt="Vue logo" class="logo" src="@/assets/logo.png">

		<section class="content font-sans">
			<p>Use this app to create a <span class="color-y">custom.json</span> file.</p>

			<p>
				Put the file in your <span class="color-b">Levels</span> folder<br>
				to play as NPCs and start with custom weapons.
			</p>
			<p>To publish, upload the file with your level inside a ZIP.</p>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'Home',
	}
</script>

<style lang="scss" scoped>
	.home {
		text-align: center;
	}

	.logo {
		height: 128px;
		width: 128px;
		margin-top: 20px;
		margin-bottom: 40px;
	}

	p {
		font-size: 1.4rem;
		margin-bottom: 20px;
	}
</style>
